/** * @author Rajesh Bodapati * @email rajesh.bodapati@ul.com * @create date 2021-05-24 14:20:16 *
@modify date 2021-05-24 14:20:16 * @desc [description] */
<template>
  <div id="rbacServicesModal" class="modal fade" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content first-modal-content">
        <div class="modal-header modal-bgcolor">
          <button type="button" class="close" @click="cancelPermissions">&times;</button>
          <div class="modal-title">{{ selectedRoleName }}</div>
          <hr />
        </div>
        <div class="modal-body service-access">
          <div class="col-xs-12">
            <button class="btn emergo-green-button float-right" @click="addService">
              <i class="fa fa-plus"></i> Add Service
            </button>
          </div>
          <div class="col-md-12 col-sm-12 col-xs-12 pt-5" v-if="roleServices.length">
            <div class="col-md-12 col-sm-12 col-xs-12 bt-border">
              <div class="row">
                <div class="col-sm-6 col-xs-5 pd">Services access</div>
                <div class="col-sm-3 col-xs-2 txt-alg-rt">Permissions</div>
                <div class="col-sm-3 col-xs-5 xs-pd-lt-50">Action</div>
              </div>
            </div>
            <div
              v-for="(service, index) in roleServices"
              :key="index"
              class="col-md-12 col-sm-12 col-xs-12 bt-border"
            >
              <div class="row pb-8 pt-8">
                <div class="col-sm-6 col-xs-6 pd">
                  <span class="checkbox inline-checkbox">
                    <label>
                    <input type="checkbox" class="form-control" v-model="service.access" />
                    <span class="cr"></span></label>
                  </span>
                  <span class="cust_label label-selected">{{ service.name }}</span>
                </div>
                <div class="col-sm-3 col-xs-2">
                  <div class="edit-lnk" @click="openPermissionsPopup(service)">edit</div>
                </div>
                <div class="col-sm-3 col-xs-4 xs-pd-lt-10">
                  <a
                    class="text-color-delete-red"
                    @click="deleteService(service.name)"
                    :disabled="
                      service.name == 'Smart Exchange' ||
                      service.name == 'Smart Builder' ||
                      service.name == 'Launchpad' ||
                      service.name == 'Regulatory Watch Admin' ||
                      service.name == 'Representation Resources'
                    "
                  >
                    <img
                      src="/static/images/icons/delete_icon.svg"
                      class="tracker-images"
                      alt="delete-icon"
                    />
                    <span>Delete</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <template v-if="addServiceFlag">
            <div class="col-sm-12 col-xs-12 col-md-12 operations mb-80">
              Add Services
              <div class="row label_container">
                <div class="col-sm-6 col-xs-6 custom-dropdown">
                  <multiselect
                    :showLabels="false"
                    :close-on-select="true"
                    :allow-empty="false"
                    class="multiselect-single-dropdown"
                    :class="!addServiceSelected ? 'un-selected' : ''"
                    :searchable="true"
                    :options="addServices.map((service) => service.id)"
                    :custom-label="
                      (option) => addServices.find((service) => service.id == option).name
                    "
                    v-model="addServiceSelected"
                    @input="addServiceToList"
                    placeholder="Select Service"
                  >
                    <span slot="noResult">No matching data</span>
                  </multiselect>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="col-sm-12 col-xs-12 col-md-12 footer remove_button_padding">
          <div class="col-xs-offset-4 col-xs-12 update-note">
            Note: changes will override user customizations
          </div>
          <div class="col-md-3 col-md-offset-6 col-sm-offset-5 col-sm-3 col-xs-5 xs-pd-lt-0">
            <button
              type="button"
              class="btn btn-block emergo-white-button"
              @click="cancelPermissions"
            >
              Cancel
            </button>
          </div>
          <div class="col-md-3 col-sm-4 col-xs-7 xs-pd-lt-0 xs-pd-rt-0">
            <button
              type="button"
              class="btn btn-block emergo-green-button"
              @click="saveServices"
              :disabled="loaderStatus"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <rbac-modules-modal
      :roleServices="roleServices"
      :serviceId="serviceId"
      @updatePermissions="updatePermissions"
      @updateServiceId="updateServiceId"
    ></rbac-modules-modal>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>
<script>
import $ from 'jquery';
import cloneDeep from 'lodash/cloneDeep';
import RBACModulesModal from './RBACModulesModal.vue';
import { getServicesListWithRBAC } from '../../apis/marketPlace';
import { updateRole } from '../../apis/rbac';
import Loader from '../UIComponents/Loader.vue';
import EventBus from '../../utils/event-bus';

export default {
  components: {
    Loader,
    'rbac-modules-modal': RBACModulesModal
  },
  props: ['roleDetails', 'selectedRoleServices', 'selectedRoleName', 'selectedRoleId'],
  data() {
    return {
      loaderStatus: false,
      serviceId: null,
      addServicesList: [], // API data
      roleServices: [], // list of services
      serviceIdsList: [], // list of service ids
      addServices: [], // list of services to be added
      addServiceSelected: '', // selected service to add for roleServices list
      addServiceFlag: false
    };
  },
  mounted() {
    $('#rbacServicesModal').on('shown.bs.modal', () => {
      this.loaderStatus = true;
      this.roleServices = cloneDeep(this.selectedRoleServices);
      this.serviceIdsList = this.roleServices.map((service) => service.id);
      this.loaderStatus = false;
    });
  },
  methods: {
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },

    async saveServices() {
      this.loaderStatus = true;
      const data = {
        role_id: this.roleDetails.role_id,
        role_name: this.roleDetails.role_name,
        description: this.roleDetails.description,
        is_active: this.roleDetails.is_active,
        account_type: this.roleDetails.account_type,
        services: this.roleServices
      };
      const response = await updateRole(data);
      if (response) {
        if (response.status_code === 200) {
          EventBus.$emit('updateRoleList');
        } else {
          this.clearNotifications();
          this.$notify({
            type: 'error',
            title: 'Role',
            text: 'Update Role Failed',
            group: 'custom-notification'
          });
        }
        this.loaderStatus = false;
        this.cancelPermissions();
      }
    },
    updateServiceId() {
      this.serviceId = null;
    },
    updatePermissions(permissions, serviceId) {
      this.roleServices.forEach((service, index) => {
        if (service.id === serviceId) {
          this.roleServices[index] = permissions;
        }
      });
      this.serviceId = null;
    },
    deleteService(name) {
      this.roleServices = this.roleServices.filter((service) => service.name !== name);
      this.updateServiceListAfterAdd();
    },
    updateServiceListAfterAdd() {
      this.serviceIdsList = this.roleServices.map((service) => service.id); // To update service ids list
      if (this.addServicesList.length > 0) {
        this.addServices = [];
        this.addServices = this.addServicesList.filter(
          (service) => !this.serviceIdsList.includes(service.id)
        );
        this.addServiceSelected = '';
      }
    },
    addServiceToList() {
      const selectedService = this.addServices.find(
        (service) => service.id === this.addServiceSelected
      );
      this.roleServices.push({
        access: selectedService.service.access,
        name: selectedService.name,
        id: selectedService.id,
        service_id: selectedService.id,
        key: selectedService.service.key,
        modules: selectedService.service.modules
      });
      this.updateServiceListAfterAdd();
    },
    async addService() {
      this.loaderStatus = true;
      this.addServiceFlag = true;
      const response = await getServicesListWithRBAC();
      this.addServicesList = response.filter((service) => service.id !== 5 && service.id !== 8); // Removed QMS & Regulatory Training & Compliance
      this.addServices = this.addServicesList.filter(
        (service) => !this.serviceIdsList.includes(service.id)
      );
      this.loaderStatus = false;
    },
    openPermissionsPopup(service) {
      this.serviceId = service.id;
      $('#rbacModulesModal').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    cancelPermissions() {
      $('#rbacServicesModal').modal('hide');
      this.roleServices = {};
      this.addServicesList = [];
      this.addServices = [];
      this.addServiceSelected = '';
      this.addServiceFlag = false;
    }
  },
  created() {}
};
</script>
<style scoped lang="scss">
$font-family-Roboto: Roboto;
$font-style-normal: normal;
.modal-header {
  padding: 15px 30px;
  &.modal-bgcolor {
    background-color: $deep-white;
    border: 0px;
    border-radius: 5px;
    padding-bottom: 0px;
  }
  .close {
    background: none;
    opacity: 0.5;
    height: 17px;
    line-height: 28px;
    color: $deep-gray;
    width: 17px;
    border-radius: 20px;
    font-weight: $font-weight-small;
    outline: none;
    font-size: $font-38;
    z-index: 1;
  }
}
.modal-title {
  font-family: $font-family-Roboto;
  font-style: $font-style-normal;
  font-weight: $font-weight-medium;
  font-size: $font-20;
  color: $primary;
}
.modal-body {
  padding: 0px 15px 100px 15px;
  height: 75vh;
  overflow: auto;
}
.label-selected {
  color: $primary;
  font-weight: $font-weight-medium;
}
.edit-lnk {
  font-family: $font-family-Roboto;
  font-style: $font-style-normal;
  @include fontItems($font-16, 22px, $font-weight-normal);
  text-align: right;
  padding-right: 35%;
  color: $messenger-blue;
  cursor: pointer;
}
.text-color-delete-red {
  font-family: $font-family-Roboto;
  font-style: $font-style-normal;
  @include fontItems($font-16, 22px, $font-weight-normal);
  text-align: right;
  padding-right: 15%;
  color: $deep-thick-danger;
  cursor: pointer;
}
.cust_label {
  word-wrap: break-word !important;
  @include fontItems($font-14, 22px, $font-weight-small);
}
.bt-border {
  border-bottom: 1px solid $gray74;
}
.txt-alg-rt {
  text-align: right;
}
.footer {
  padding-top: 10px;
  position: absolute;
  bottom: 0%;
  padding-bottom: 2%;
  right: 0;
  background-color: $white;
}
.update-note {
  padding-bottom: 15px;
  font-size: $font-14;
  color: $primary;
  font-weight: $font-weight-medium;
}
::v-deep .multiselect-single-dropdown {
  .multiselect__content-wrapper {
    max-height: 190px !important;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .modal-dialog {
    vertical-align: top;
  }
  .modal-body {
    height: 50vh;
    overflow: auto;
  }
}
@media screen and (max-width: 767px) {
  .pd {
    padding: 0px 5px;
  }
  .update-note {
    float: right;
  }
}
@media screen and (max-width: 540px) {
  .txt-alg-rt {
    padding: 0px;
  }
  .xs-pd-lt-10 {
    padding: 0px 0px 0px 10px;
  }
  .xs-pd-lt-50 {
    padding: 0px 0px 0px 50px;
  }
}
</style>
